/**
 * Created by neo on 23.12.22.
 */
import * as React from 'react';
import { observer } from 'mobx-react';
import { useLocalizedImage } from '../../../Hooks/useLocalizedMedia';
import { getMediaLargeOrMediumOrSmallest } from '../../../Model/Media/Media';
import { KinasticVideoPlayer } from '../KinasticVideoPlayer';
import { VideoPlayerContainer } from '../../VideoPlayerContainer';
import { ArticleEntry } from '../../../Model/Explore/ArticleEntry';
import { useLocalized } from '../../../Hooks/useLocalized';

export type ExploreContentViewArticleTeaserProps = {
  entry: ArticleEntry;
};

export const ExploreContentViewVideoPlayer: React.FC<ExploreContentViewArticleTeaserProps> = observer(({ entry }) => {
  const entryImage = useLocalizedImage(entry.images);

  const image = entryImage ? getMediaLargeOrMediumOrSmallest(entryImage) : undefined;

  return (
    <VideoPlayerContainer backgroundImageUrl={image}>
      <KinasticVideoPlayer
        videos={entry.videos}
        title={useLocalized(entry.name)}
        entryId={entry.id}
        showLanguageSelector={true}
        analyticsConfig={{
          contentId: entry.id,
          contentType: 'video',
          mediaType: 'article',
          contentName: entry.defaultName,
        }}
      />
    </VideoPlayerContainer>
  );
});
